import React from "react";
import { Link } from "react-router-dom";
import { Film, Instagram, Linkedin, Youtube } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function MarketingFooter() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#080F1B] text-white/80 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-gold text-petroleum">
              <Film size={18} />
            </span>
            <span className="font-display text-2xl text-white">
              Cine<span className="text-gold">ngage</span>
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm text-white/60 leading-relaxed">
            {t("footer.description")}
          </p>
          <div className="mt-6 flex items-center gap-4 text-white/60">
            <a href="#" aria-label="Instagram" className="hover:text-gold"><Instagram size={18} /></a>
            <a href="#" aria-label="LinkedIn" className="hover:text-gold"><Linkedin size={18} /></a>
            <a href="#" aria-label="Youtube" className="hover:text-gold"><Youtube size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="eyebrow text-gold mb-4">{t("footer.platform")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/como-funciona" className="hover:text-white">{t("nav.how_it_works")}</Link></li>
            <li><Link to="/explorar" className="hover:text-white">{t("footer.explore_projects")}</Link></li>
            <li><Link to="/registro" className="hover:text-white">{t("nav.register")}</Link></li>
            <li><Link to="/login" className="hover:text-white">{t("nav.login")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow text-gold mb-4">{t("footer.brand_col")}</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#" className="hover:text-white">{t("footer.about")}</a></li>
            <li><a href="#" className="hover:text-white">{t("footer.press")}</a></li>
            <li><a href="#" className="hover:text-white">{t("footer.terms")}</a></li>
            <li><a href="#" className="hover:text-white">{t("footer.privacy")}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-white/40">
        {t("footer.copyright", { year: new Date().getFullYear() })}
      </div>
    </footer>
  );
}
